import { Container, IDestroyOptions, Point, Text, TextStyle, Texture } from "pixi.js";
import { GameFont } from "../../GameFont";
import { Avatar } from "../Avatar";
import { UserProfileResourcePackage } from "../../../popups/userprofile/resources/UserProfileResourcePackage";

export class ProfileContainer extends Container {
    protected profileContainer: Container;
    private avatar: Avatar;
    private firstNameField: Text;

    public constructor(
        userProfileResources: UserProfileResourcePackage,
        avatarIcon: Texture,
        name: string) {
        super();
        this.profileContainer = new Container();
        this.avatar = new Avatar(userProfileResources, avatarIcon);
        this.avatar.avatarSize = new Point(63, 63);
        this.avatar.position.set(-36, -32);
        this.avatar.glow = true;
        this.profileContainer.addChild(this.avatar);
        this.firstNameField = new Text(name.toUpperCase(), new ProfileTextStyle());
        this.firstNameField.anchor.set(0.5, 0.5);
        this.firstNameField.x = this.avatar.width * 0.6 + this.firstNameField.width * 0.5;
        this.profileContainer.addChild(this.firstNameField);
        this.profileContainer.x = this.avatar.width * 0.5 - this.profileContainer.width * 0.5;
        this.addChild(this.profileContainer);
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        super.destroy(options);
    }
}

class ProfileTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            dropShadow: true,
            dropShadowAngle: 0.5,
            dropShadowBlur: 3,
            dropShadowDistance: 2,
            align: "center",
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 42
        }));
    }
}
